'use strict';

angular.module('cgmemApp')
  .config(function ($stateProvider) {
    $stateProvider
      .state('authenticated.transactions', {
        url: '/transactions',
        templateUrl: 'app/adminTransactions/adminTransactions.html',
        controller: 'AdminTransactionsCtrl',
        controllerAs: '$ctrl'
      });
  });